/**
 *
 * @param {object} equipment equipment object
 * @param {object} overriddenParams
 * @param {boolean} overriddenParams.showModel show model in title or not
 * @param {boolean} overriddenParams.showOfficialNumber show registration number in title or not
 * @param {boolean} overriddenParams.showInnerNumber show household
 * @param {boolean} overriddenParams.showVinNumber show vin number in title or not
 * @param {boolean} overriddenParams.showInventoryNumber show inventory number in title or not
 * @param {string} overriddenParams.titleIfEmpty title if technic is empty
 * @returns {string} formatted title
 */
//TODO: need to check
export const getEquipmentTitle = (equipment, overriddenParams) => {
	if(!equipment || Object.keys(equipment).length === 0) return null

	const defaultParams = {
		showModel: true,
		showOfficialNumber: true,
		showInnerNumber: false,
		showVinNumber: false,
		showInventoryNumber: false,
		titleIfEmpty: null
	}

	const params = Object.assign(defaultParams, overriddenParams)


	const numberAttrsToAddingToTitle = []

	if (params.showOfficialNumber) numberAttrsToAddingToTitle.push('official_number')
	if (params.showInnerNumber) numberAttrsToAddingToTitle.push('inner_number')
	if (params.showVinNumber) numberAttrsToAddingToTitle.push('vin_number')
	if (params.showInventoryNumber) numberAttrsToAddingToTitle.push('inventory_number')


	const canShowFewNumbers = numberAttrsToAddingToTitle.length > 1

	let title = ''
	if (equipment.brand) {
		title += equipment.brand
	}
	if (params.showModel && equipment.model) {
		title += ` ${equipment.model}`
	}

	if (canShowFewNumbers) {
		title += ' ( '

		title += numberAttrsToAddingToTitle
							.map((numberAttr) => {
									if (equipment[numberAttr]) {
										return equipment[numberAttr]
									}
							})
							.join(', ')

		title += ' )'

	} else {

		if (params.showOfficialNumber && equipment?.official_number) {
			title += ` (${equipment.official_number})`
		}
		if (params.showInnerNumber && equipment?.inner_number) {
			title += ` (${equipment.inner_number})`
		}
		if (params.showVinNumber && equipment?.vin_number) {
			title += ` (${equipment.vin_number})`
		}
		if (params.showInventoryNumber && equipment?.inventory_number) {
			title += ` (${equipment.inventory_number})`
		}
	}
	if (params.showSecondNumber && equipment?.inner_number) {
		title += ` ${equipment.inner_number}`
	}
	return title || params.titleIfEmpty
}